import React  from 'react';
import PropTypes from 'prop-types';

const LMSIcon = (props) => {
  const { width, height, isActive } = props;
  let color;
  if (isActive) {
    color = '#FF4200';
  }
  else {
    color = '#AEB2BF';
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 24">
      <path fill={color} d="M11.864 16.378a3.913 3.913 0 0 1-1.124 2.468l-2 2a3.956 3.956 0 0 1-5.586 0 3.954 3.954 0 0 1 0-5.586l2-2a3.916 3.916 0 0 1 2.468-1.124l1.816-1.816c-1.974-.51-4.155-.017-5.698 1.527l-2 2a5.956 5.956 0 0 0 0 8.414A5.935 5.935 0 0 0 5.947 24c1.523 0 3.047-.58 4.207-1.74l2-2c1.543-1.543 2.036-3.724 1.527-5.698l-1.817 1.816z"/>
      <path fill={color} d="M16.378 11.864a3.913 3.913 0 0 0 2.468-1.124l2-2a3.956 3.956 0 0 0 0-5.586 3.954 3.954 0 0 0-5.586 0l-2 2a3.916 3.916 0 0 0-1.124 2.468L10.32 9.438c-.51-1.974-.017-4.155 1.527-5.698l2-2a5.956 5.956 0 0 1 8.414 0A5.935 5.935 0 0 1 24 5.947c0 1.523-.58 3.047-1.74 4.207l-2 2c-1.543 1.543-3.724 2.036-5.698 1.527l1.816-1.817z"/>
      <path fill={color} d="M7.586 15L15 7.586 16.414 9 9 16.415 7.586 15z"/>
    </svg>
  );
};

LMSIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isActive: PropTypes.bool,
};

LMSIcon.defaultProps = {
  width: 24,
  height: 24,
  isActive: false,
};

export default LMSIcon;
